<div class="wrapper">
    <!-- <div style="display: flex; justify-content: space-between; align-items: center; padding: 0 40px">
        <h1 mat-dialog-title class="title-admin">{{'chinh_sua_noi_dung' | translate}}</h1>
        <div mat-button mat-dialog-close class="close" nz-icon nzType="close-circle"></div>
    </div> -->
    <div style="display: flex; justify-content: center; align-items: center; gap: 12px; padding: 0 40px 0 40px;">
        <!-- chọn ngôn ngữ đa ngôn ngữ -->
        <app-select-language-config [displayLabel]="true"></app-select-language-config>
    </div>

    <!-- Danh sách menu -->
    <div class="widget-row-elementor">
        <div class="list-menu" style="height: 100%">
            <!-- Tiêu đề -->
            <div class="heading-menu">
                <h3 class="m-0 menu-title" style="font-weight:500;">{{'cau_truc_menu' | translate}}</h3>
                <div class="nav-header">
                    <button nz-button style="border:1px solid #008848; color:#008848; margin-right:15px;"
                        (click)="openAddMenuItem()">{{'them_menu' | translate}}</button>
                </div>
            </div>
             <!-- Danh sách menu  -->
             <div class="elementor-custom" style="overflow-y: scroll;min-height: 500px;max-height: 300px; height: calc(100% - 100px);">
                    <mat-tree cdkDropList (cdkDropListDropped)="cdkDropListDropped($event)"
                        [dataSource]="dataSource" [treeControl]="treeControl"  [trackBy]="trackById">
                        <mat-tree-node [id]="node._id" [attr.group]="node.group" [attr.data-level]="node.level" cdkDrag  *matTreeNodeDef="let node" matTreeNodePadding>
                          <div class="w-100 tree_node">
                            <div style="display: flex; align-items: center">
                                <div style="padding: 0 10px; display: inline-block; cursor: move">
                                  <i nz-icon nzType="menu" nzTheme="outline"></i>
                                </div>
                                <!-- Có menu con thì thêm icon expand_more phía trước -->
                                <button mat-icon-button *ngIf="node.expandable" matTreeNodeToggle [attr.aria-label]="'Toggle ' + node['name_' + functionService.languageTempCode] | vhLanguage : 'name' : 'AtwMenu'">
                                    <mat-icon class="mat-icon-rtl-mirror">
                                    {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                                    </mat-icon>
                                </button>
                                <!-- Không có menu con thì thêm button disabled để có padding phía trước -->
                                <button *ngIf="!node.expandable" mat-icon-button disabled></button>
                                <!-- Icon của menu -->
                                <span *ngIf="node.icon">
                                    <mat-icon class="mr-2">{{node.icon}}</mat-icon>
                                </span>
                                <!-- Nội dung menu -->
                                {{node['name_' + functionService.languageTempCode] | vhLanguage : 'name' : 'AtwMenu'}}
                            </div>
                            <!-- Danh sách các nút thao tác -->
                            <div class="btn-foundation">
                                <!-- Thêm icon -->
                                <button nz-button nzShape="circle" nz-tooltip nzTooltipTitle="{{'them_icon' | translate}}"
                                    (click)="addIconToParent(node)">
                                    <i class="bi bi-star"></i>
                                </button>
                                <!-- Xoá icon -->
                                <button nz-button nzShape="circle" nz-tooltip nzTooltipTitle="{{'xoa_icon' | translate}}"
                                    (click)="deleteIcon(node)">
                                    <i class="bi bi-slash-circle-fill"></i>
                                </button>
                                <!-- Thêm menu con -->
                                <button nz-button nzShape="circle" nz-tooltip nzTooltipTitle="{{'them_menu_con' | translate}}"
                                    *ngIf="node.group != 'category' && !node.id_freeblock"
                                    (click)="openAddSubMenuItem(node)">
                                    <i class="bi bi-plus"></i>
                                </button>
                                <!-- Gọi cây danh mục -->
                                <button nz-button nzShape="circle" nz-tooltip nzTooltipTitle="{{'goi_cay_danh_muc' | translate}}"
                                    *ngIf="(node.group == 'category' || node.group == 'pop-up-subcategory') && node.level == 0"
                                    (click)="openAddSubMenuItem(node)">
                                    <i class="bi bi-text-center"></i>
                                </button>
                                <!-- Chỉnh sửa menu -->
                                <button nz-button nzShape="circle" nz-tooltip nzTooltipTitle="{{'chinh_sua_menu' | translate}}"
                                    *ngIf="node.group != 'category' || (node.group == 'category' && node.level == 0)"
                                    (click)="openEdit(node)">
                                    <i class="bi bi-pencil"></i>
                                </button>
                                <!-- Xóa -->
                                <button 
                                  nz-popconfirm
                                  nzPopconfirmTitle="{{'ban_co_chac_chan_muon_xoa_menu_nay' | translate}}"
                                  nzPopconfirmPlacement="bottom"
                                  nz-button 
                                  nzShape="circle" 
                                  nz-tooltip 
                                  nzTooltipTitle="{{'xoa' | translate}}"
                                  *ngIf="node.group != 'category' || (node.group == 'category' && node.level == 0)"
                                  (nzOnConfirm)="removeMenuItem(node)"
                                  
                                  >
                                    <i class="bi bi-trash"></i>
                                </button>
                            </div>
                          </div>
                        </mat-tree-node>
                    </mat-tree>
            </div>
        </div>
    </div>
</div>
<!-- MODAL THÊM MENU -->
<nz-modal [(nzVisible)]="isOpenAddMenu" [nzFooter]="null"
    [nzStyle]="{width: '60vw', top: '5%',position: 'relative'}" nzCloseIcon 
    [nzTitle]="titleAddMenu" nzCancelText="{{'huy' | translate}}" nzOkText="{{'luu' | translate}}">
    <ng-container *nzModalContent>
        <app-add-menu-header-admin
            (isAddMenu)="isCancelFormAddMenu($event)"
            [data]="dataAddMenu"
            [type]="data.type"
            (valueData)="getDataFormAdd($event)"
            [isAutoTranslate]="isAutoTranslate">
        </app-add-menu-header-admin>
    </ng-container>
    <ng-template #titleAddMenu>
        <p class="m-0 title" style="font-weight:400;">{{'them_menu' | translate}}</p>
    </ng-template>
</nz-modal>
<!-- MODAL SỬA MENU -->
<nz-modal [(nzVisible)]="isOpenEditMenu" [nzFooter]="null"
    [nzStyle]="{width: '60vw', top: '5%',position: 'relative'}" nzCloseIcon
    [nzTitle]="titleEditMenu" nzCancelText="{{'huy' | translate}}" nzOkText="{{'luu' | translate}}">
    <ng-container *nzModalContent>
        <app-edit-menu-header-admin 
            (isEditMenu)="isCancleFormEditMenu($event)"
            [data]="dataEditMenu"
            [type]="data.type"
            (valueDataEdited)="getValueFormEditMenu($event)"
            [isAutoTranslate]="isAutoTranslate">
        </app-edit-menu-header-admin>
    </ng-container>
    <ng-template #titleEditMenu>
        <p class="m-0 title" style="font-weight:400;">{{'chinh_sua_menu' | translate}}</p>
    </ng-template>
</nz-modal>
<!-- MODAL THÊM MENU PHỤ -->
<nz-modal [(nzVisible)]="isOpenAddFormSubMenu" [nzFooter]="null"
    [nzStyle]="{width: checkExistIdCategory ? '30vw' : '50vw'}" nzCloseIcon
    [nzTitle]="titleAddSubMenu" nzCancelText="{{'huy' | translate}}" nzOkText="{{'luu' | translate}}">
    <ng-container *nzModalContent>
        <app-add-sub-menu-header-admin 
            [data]="dataAddSubMenu"
            (isCancelFormAddSub)="isCancelFormAddSub($event)"
            (valueDataAdd)="getValueFormAddSub($event)"
            (getDataCategoryAgain)="getDataCategoryAgain($event)"
            [isAutoTranslate]="isAutoTranslate">
        </app-add-sub-menu-header-admin>
    </ng-container>
    <ng-template #titleAddSubMenu>
        <p class="m-0 title" style="font-weight:400;">{{'them_menu_con' | translate}}</p>
    </ng-template>
</nz-modal>
<!-- MODAL CHỈNH SỬA MENU PHỤ -->
<nz-modal [(nzVisible)]="isOpenEditFormSubMenu" [nzFooter]="null"
    [nzStyle]="{width: '50vw'}" nzCloseIcon
    [nzTitle]="titleEditSubMenu" nzCancelText="{{'huy' | translate}}" nzOkText="{{'luu' | translate}}">
    <ng-container *nzModalContent>
        <app-edit-sub-menu-header-admin (isCancelFormEditSub)="isCancleFormEditSub($event)"
            [data]="dataEditSubMenu"
            (valueDataEdit)="getValueFormEditSub($event)"
            [isAutoTranslate]="isAutoTranslate">
        </app-edit-sub-menu-header-admin>
    </ng-container>
    <ng-template #titleEditSubMenu>
        <p class="m-0 title" style="font-weight:400;">{{'chinh_sua_menu_con' | translate}}</p>
    </ng-template>
</nz-modal>